import React, { useEffect, useState } from 'react'
import { View, StyleSheet } from 'react-native'
import { InvoiceProcessed } from '../../../components/InvoiceProcessed'
import PaymentInfo from '../../../components/PaymentInfo'
import InfoAlert from '../../../components/InfoAlert'
import CreatePassword from '../../../components/CreatePassword'

const InvoiceReceiptWeb = ({
  invoice,
  paymentMethodData: initialPaymentMethodData,
  onCreateAccount,
}) => {
  const [paymentMethodData, setPaymentMethodData] = useState(() => {
    if (initialPaymentMethodData) {
      return initialPaymentMethodData
    }
    const storedPaymentMethodData = localStorage.getItem('paymentMethodData')
    return storedPaymentMethodData ? JSON.parse(storedPaymentMethodData) : null
  })

  useEffect(() => {
    if (initialPaymentMethodData) {
      setPaymentMethodData(initialPaymentMethodData)
    }
  }, [initialPaymentMethodData])

  if (!paymentMethodData) {
    return null
  }

  return (
    <View style={styles.pageContainer}>
      {/* Left Section */}
      <View style={styles.leftSection}>
        <View style={styles.paymentInfoContainer}>
          <InvoiceProcessed />
          <PaymentInfo
            invoice={invoice}
            paymentMethodData={paymentMethodData}
          />
        </View>
      </View>

      {/* Right Section */}
      <View style={styles.rightSection}>
        <View style={styles.signUpContainer}>
          <View style={styles.infoAlert}>
            <InfoAlert />
          </View>

          <CreatePassword onPress={onCreateAccount} />
        </View>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  pageContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
  leftSection: {
    flex: 1,
    width: '50%',
    height: '100%',
    backgroundColor: '#F8F9F9',
    justifyContent: 'flex-start',
  },
  paymentInfoContainer: {
    alignItems: 'center',
    minWidth: 320,
    width: '67%',
    maxWidth: 610,
    justifyContent: 'center',
    alignSelf: 'center',
    marginTop: 40,
  },
  infoAlert: {
    paddingHorizontal: 60,
    marginBottom: 10,
  },
  signUpContainer: {
    alignItems: 'center',
    width: '74%',
    minWidth: 400,
    maxWidth: 640,
    justifyContent: 'center',
    alignSelf: 'center',
    marginTop: 100,
  },
  rightSection: {
    flex: 1,
    width: '50%',
    justifyContent: 'flex-start',
  },
})

export default InvoiceReceiptWeb
